"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Tabs = _interopRequireDefault(require("./Tabs"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: left;\n    padding: 0 15px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 16px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 34px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PricingPageTitle = _styledComponents.default.h1.withConfig({
  displayName: "TabLayout__PricingPageTitle",
  componentId: "sc-1c8nzyz-0"
})(["font-size:28px;color:", ";", ""], _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject()));

var PricingPageSubtitle = _styledComponents.default.p.withConfig({
  displayName: "TabLayout__PricingPageSubtitle",
  componentId: "sc-1c8nzyz-1"
})(["font-size:14px;color:", ";.pricing-page-subtitle-link{text-decoration:underline;color:", ";}", ";"], _colors.OLAF, _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject2()));

var HeaderTitle = _styledComponents.default.div.withConfig({
  displayName: "TabLayout__HeaderTitle",
  componentId: "sc-1c8nzyz-2"
})(["text-align:center;", ""], _responsiveBreakpoints.default.phone(_templateObject3()));

var HeaderGradient = _styledComponents.default.div.withConfig({
  displayName: "TabLayout__HeaderGradient",
  componentId: "sc-1c8nzyz-3"
})(["position:absolute;z-index:-100;background-color:#00bda5;background-image:linear-gradient( -303deg,", ",0%,#00afb2 56%,", " 100% );width:100%;height:100%;"], _colors.CALYPSO, _colors.OZ);

var HeaderBackdrop = function HeaderBackdrop() {
  return _react.default.createElement("span", null, _react.default.createElement(HeaderGradient, null), _react.default.createElement(HeaderTitle, {
    className: "m-auto-y-0"
  }, _react.default.createElement(PricingPageTitle, {
    className: "p-top-8 p-bottom-2 m-bottom-0"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.title"
  })), _react.default.createElement(PricingPageSubtitle, {
    className: "p-bottom-8 m-bottom-0"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.subTitle"
  }))));
};

var TabLayout = function TabLayout(_ref) {
  var selectedPrimaryTab = _ref.selectedPrimaryTab,
      selectedSecondaryTab = _ref.selectedSecondaryTab,
      children = _ref.children;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(HeaderBackdrop, null), _react.default.createElement(_Tabs.default, {
    selectedPrimaryTab: selectedPrimaryTab,
    selectedSecondaryTab: selectedSecondaryTab
  }), children);
};

var _default = TabLayout;
exports.default = _default;
module.exports = exports.default;